<div class="flex flex-col items-center">
    <img src="../../assets/images/PEFPoster.png" class="w-[30%]" />
    <h1>Scholarship Application Login</h1>
    <div class="flex flex-wrap justify-center gap-[100px] mt-[20px]">
        <mat-card class="p-[10px] w-[400px] bg-white border border-solid border-black flex flex-col justify-between h-full">
            <mat-toolbar class="p-[10px] mb-[10px] min-h[64px]"><span>Charter School Student Register</span></mat-toolbar>
            <p>
                If you are a student at a charter school, you must register an
                account first. After you register, you will be given a PCPS username,
                which you can use to login along with the password you created.
            </p>
            <p>
                If you already have an account and don't remember your password,
                you can use the 'Forgot Password' tool located in the login box.
            </p>
            <div>
                <button mat-flat-button type="button" routerLink="/register">
                    Register
                </button>
            </div>
        </mat-card>
        <mat-card class="p-[10px] w-[400px] bg-white border border-solid border-black">
            <form [formGroup]="lForm" (ngSubmit)="login(lForm)" novalidate class="flex flex-col justify-between h-full">
                <mat-toolbar class="p-[10px] mb-[10px] min-h[64px]"><span>Public and Charter Login</span></mat-toolbar>
                <mat-form-field class="w-full">
                    <mat-label>PCPS Username</mat-label>
                    <input matInput formControlName="username" />
                    <mat-icon matSuffix>person</mat-icon>
                    @if (lForm.get('username').hasError('required')) {
                    <mat-error>response required</mat-error>
                    }
                </mat-form-field>
                <mat-form-field class="w-full">
                    <mat-label>Password</mat-label>
                    <input matInput type="password" formControlName="password" />
                    <mat-icon matSuffix (click)="impersonation($event)">lock_outline</mat-icon>
                    @if (lForm.get('password').hasError('required')) {
                    <mat-error>response required</mat-error>
                    }
                </mat-form-field>
                @if (showAdditionalFields === true) {
                @if (isDevMode === false) {
                <mat-form-field class="w-full">
                    <mat-label>Impersonated Username</mat-label>
                    <input matInput formControlName="impersonatedUsername" />
                </mat-form-field>
                }
                @else {
                <mat-radio-group formControlName="impersonationSelection" class="flex flex-col w-full">
                    <mat-radio-button value="username" class="radio-full-width">
                        <mat-form-field class="w-full">
                            <mat-label>Impersonated Username</mat-label>
                            <input matInput formControlName="impersonatedUsername" />
                        </mat-form-field>
                    </mat-radio-button>
                    <mat-radio-button value="training1">Training Student 1</mat-radio-button>
                    <mat-radio-button value="training2">Training Student 2</mat-radio-button>
                </mat-radio-group>
                <mat-checkbox formControlName="clearTraining">Clear Training Data?</mat-checkbox>
                }
                }
                <div class="flex justify-between">
                    <button mat-flat-button type="submit">
                        Login
                    </button>
                    <button mat-raised-button type="button" (click)="forgotPassword()">
                        Forgot Password
                    </button>
                </div>
            </form>
        </mat-card>
    </div>
</div>